<template>
  <v-layout row wrap>
    <v-col cols :sm="12" class="pa-0">
      <v-card v-show="!Order.isForm" flat class="pa-2 text-no-wrap">
        <h2 class="pa-2">
          {{ $t(`table.filter`) }}
        </h2>
        <v-layout align-center>
          <v-col cols :sm="3" class="pa-2">
            <v-text-field
              :label="$t(`table.search`) + ' UserId'"
              dense
              hide-details
              @keydown.enter="_fnSearchUserId"
            />
          </v-col>
        </v-layout>
        <v-data-table
          dense
          must-sort
          fixed-header
          item-key="id"
          :items="Order.list"
          :options.sync="pagings"
          :headers="cTableHeaders"
          :server-items-length="Order.total"
          :items-per-page="Order.filter.limit"
          :footer-props="{ itemsPerPageOptions: Order.itemPages }"
          :item-class="(e) => (id == e.id ? 'primary lighten-5' : '')"
        >
          <template v-slot:top>
            <v-layout px-2 justify-space-around align-end>
              <v-layout align-center>
                <h2>{{ $t("menu.order") }}</h2>
              </v-layout>
            </v-layout>
          </template>
          <template #[`item.action`]="{ item }">
            <v-btnc
              color="warning"
              icon="mdi-pencil"
              @click="
                fnCallUpdateView({ model, item: item });
                _fnLoadData();
              "
              v-if="fnCheckMission(Session, [{ m: ORDER, p: APPROVE }])"
            />
          </template>
          <template #[`item.user`]="{ item }">
            {{ "LomoId: " + (item.user.lomoId || "") }}<br />
            {{ "UserId: " + item.user.id }}<br />
          </template>
          <template #[`item.gift`]="{ item }">
            {{ item.gift.title }}
          </template>
          <template #[`item.address`]="{ item }">
            <span v-if="item.province">{{
              `${item.address}, ${item.ward.name}, ${item.district.name}, ${item.province.name}`
            }}</span>
          </template>
          <template #[`item.status`]="{ item }">
            <span
              :class="
                item.status.id == '5ff40b7289e3051a47e7cfe9'
                  ? 'success--text'
                  : item.status.id == '5ffe614c612c620ee29036d0'
                  ? 'warning--text'
                  : 'info--text'
              "
            >
              {{ item.status.name }}
            </span>
          </template>
          <template #[`item.createdAt`]="{ item }">
            {{ item.createdAt | mDateTime }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <v-col cols :sm="12" class="pa-0"><v-dialog /></v-col>
  </v-layout>
</template>

<script>
import Dialog from "./dialog.vue";

export default {
  components: {
    "v-dialog": Dialog,
  },
  data() {
    return {
      id: "",
      model: "Order",
      pagings: {},
    };
  },
  computed: {
    cTableHeaders() {
      let table = [
        {
          text: this.$t(`table.action`),
          sortable: false,
          value: "action",
          width: "10px",
        },
        {
          text: this.$t(`table.id`),
          value: "user",
          width: "10px",
        },
        {
          text: this.$t(`table.name`),
          value: "name",
        },
        {
          text: this.$t(`table.phone`),
          value: "phone",
          width: "10px",
        },
        {
          text: this.$t(`table.email`),
          value: "email",
          width: "10px",
        },
        {
          text: this.$t(`table.gift`),
          value: "gift",
          width: "10px",
        },
        {
          text: this.$t(`table.candy`),
          value: "total",
          width: "10px",
        },
        {
          text: this.$t(`table.status`),
          value: "status",
          width: "10px",
        },
        {
          text: this.$t(`table.createdAt`),
          value: "createdAt",
          width: "10px",
        },
        {
          text: this.$t(`table.address`),
          value: "address",
        },
      ];
      return table;
    },
  },
  watch: {
    "Order.isRefresh": function (val) {
      if (val) {
        this._fnCallListView();
      }
    },
    pagings: function (val) {
      const { itemsPerPage, page, sortBy, sortDesc } = val;
      this[this.model].filter.limit = itemsPerPage;
      this[this.model].filter.page = page;
      if (sortBy.length) {
        this[this.model].filter.sort = `${sortBy[0]}:${sortDesc[0] ? -1 : 1}`;
      }
      this._fnCallListView();
    },
  },
  methods: {
    _fnLoadData() {
      if (this[this.model].isCreate) {
        this[this.model].obj = { price: 0, promotion: 0 };
      } else if (this[this.model].isUpdate) {
        this.id = this[this.model].obj.id;
        this[this.model].obj = {
          ...this[this.model].obj,
          gift: this[this.model].obj.gift.id,
          status: this[this.model].obj.status.id,
        };
      }
    },
    _fnCallListView() {
      this.fnCallListView({
        url: "/v1/admin/order",
        model: this.model,
      });
    },
    _fnSearch({ target: { value } }) {
      if (!value) delete this[this.model].filter.$text;
      else this[this.model].filter.$text = value;
      this._fnCallListView();
    },
    _fnSearchUserId({ target: { value } }) {
      if (!value) delete this[this.model].filter.user;
      else this[this.model].filter.user = value;
      this._fnCallListView();
    },
  },
};
</script>
